import { Flex } from "@mantine/core";
import { useState } from "react";
import { useCollectCustomerInfo } from "@/sales-tools/home-product/hooks/useCollectCustomerInfo";
import { formatPhoneNumber } from "@/shared-utils";
import { EligibilityStatus } from "../../types";
import { SaleView } from "../StepSpecific/SaleView";
import { CollectCustomerInfoFooter } from "./CollectCustomerInfoFooter";
import { CollectCustomerInfoForm } from "./CollectCustomerInfoForm";

export function CollectCustomerInfo() {
    const {
        addressSuggestions,
        customerMdn,
        debouncedAddressSearch,
        eligibilityStatus,
        form,
        handleContinueToPayment,
        integratedStep,
        isLoading,
        isLoadingEligibility,
        product,
        sentIneligibleAddress,
    } = useCollectCustomerInfo();

    const [showManualAddressInput, setShowManualAddressInput] = useState(false);

    const showAddressNotFoundMessage =
        debouncedAddressSearch.length > 6 && !isLoading && addressSuggestions.length === 0;
    const formattedSuggestions = addressSuggestions.map((suggestion) => ({
        value: suggestion,
        label: suggestion,
    }));
    const phoneNumber = formatPhoneNumber(customerMdn).number;
    const isCustomerInfoCollected = form.isValid();
    const isNotEligible = eligibilityStatus && eligibilityStatus !== EligibilityStatus.Eligible;

    const handleAddAddressManually = () => {
        setShowManualAddressInput(true);
    };

    return isNotEligible ? (
        <Flex className="classes.saleViewContainer">
            <SaleView status={eligibilityStatus} />
        </Flex>
    ) : (
        <>
            <CollectCustomerInfoForm
                form={form}
                isAddressEligible={!sentIneligibleAddress}
                isLoading={isLoading}
                addressSuggestions={formattedSuggestions}
                phoneNumber={phoneNumber}
                showAddressNotFoundMessage={showAddressNotFoundMessage}
                onAddAddressManually={handleAddAddressManually}
                showManualAddressInput={showManualAddressInput}
            />

            <CollectCustomerInfoFooter
                product={product}
                isCustomerInfoCollected={isCustomerInfoCollected}
                isLoadingEligibility={isLoadingEligibility}
                handleContinueToPayment={handleContinueToPayment}
                integratedStep={integratedStep}
            />
        </>
    );
}
